import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../services/auth-service";

@Component({
  selector: "app-acesso-bloqueado",
  template: `
    <div style="display:flex;justify-content:center;margin-top:60px">
      <p-card header="Acesso ao sistema bloqueado" styleClass="text-center">
        <p>O uso do sistema está suspenso por pendência de pagamento.</p>
        <p>Entre em contato com o responsável para regularizar a situação.</p>
        <button
          pButton
          type="button"
          label="Voltar ao login"
          (click)="sair()"
        ></button>
      </p-card>
    </div>
  `,
})
export class AcessoBloqueadoComponent {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  sair() {
    this.auth
      .logout()
      .catch(() => this.auth.clearAccessToken())
      .finally(() => this.router.navigate(["/login"]));
  }
}
